import { SET_EMR_CLUSTER_STATUS } from 'utils/constant'

export function setEmrClusterStatus(emrClusterStatus) {
  return {
    type: SET_EMR_CLUSTER_STATUS,
    emrClusterStatus,
  }
}
